import {RouteProps} from 'config/navigation';
import CreateBonus from './create-bonus';
import {IoWallet} from 'react-icons/io5';

const walletPages: RouteProps = {
  name: 'Carteira',
  path: 'wallet',
  permission: 'wallet.addBonus',
  icon: <IoWallet />,
  subRoutes: [
    {
      path: '',
      element: <CreateBonus />,
      permissions: ['wallet.addBonus'],
    },
  ],
};

export default walletPages;
